if (!customElements.get('td-booster-ingredients')) {
  class TdBoosterIngredients extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length === 0) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
      });
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
      this.tabs[index].focus();
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next !== null) {
        event.preventDefault();
        this.activate(next);
      }
    }
  }
  customElements.define('td-booster-ingredients', TdBoosterIngredients);
}
